import React from "react";
import moment from "moment";
import { FastField, Field, Form } from "formik";
import { Output } from "../../Text";
import {
  Conditional,
  FieldDependent,
  SelectField,
  TextField,
} from "../../formik";
import { Fieldset, Layout } from "@vwfs-bronson/bronson-react";
import * as Validation from "../../validation";
import { FormSection2 } from "./FormSection";
import { DateField } from "../../formik/DateField";
import { resetField } from "../../formik/resetField";

function ContactSection({
  closed,
  success,
  showEditButton,
  onIconClick,
  form,
  buttons,
  containerRef,
}) {
  return (
    <FormSection2
      containerRef={containerRef}
      title={Output.resolve("pages.applicationForm.panels.contactData.title")}
      subtitle={Output.resolve(
        "pages.applicationForm.panels.contactData.subtitle"
      )}
      success={success}
      expanded={!closed}
      onHeaderClick={onIconClick}
      edit={
        !showEditButton
          ? undefined
          : {
              label: Output.resolve("pages.applicationForm.buttonEdit"),
              onClick: onIconClick,
            }
      }
    >
      <Form {...form} floatingLabel>
        <Fieldset>
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name="street"
                  label={Output.resolve(
                    "pages.applicationForm.panels.contactData.fields.street.label"
                  )}
                  maxLength="30"
                  component={TextField}
                />
              </Layout.Item>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name="housenumber"
                  label={Output.resolve(
                    "pages.applicationForm.panels.contactData.fields.houseNumber.label"
                  )}
                  maxLength="30"
                  component={TextField}
                />
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name="postcode"
                  label={Output.resolve(
                    "pages.applicationForm.panels.contactData.fields.postcode.label"
                  )}
                  component={TextField}
                />
              </Layout.Item>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name="city"
                  label={Output.resolve(
                    "pages.applicationForm.panels.contactData.fields.city.label"
                  )}
                  component={TextField}
                />
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name="country"
                  label={Output.resolve(
                    "pages.applicationForm.panels.contactData.fields.country.label"
                  )}
                  component={SelectField}
                >
                  {Output.resolve("generic.countrylist", []).map(
                    ({ key: value, value: label }, index) => (
                      <option key={index} value={value}>
                        {label}
                      </option>
                    )
                  )}
                </FastField>
              </Layout.Item>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name="residentSince"
                  label={Output.resolve(
                    "pages.applicationForm.panels.contactData.fields.residentSince.label"
                  )}
                  component={DateField}
                />
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <FieldDependent
            names={["residentSince"]}
            render={({ values: { residentSince }, formik }) => (
              <Conditional
                collapsed={
                  !residentSince ||
                  !moment(residentSince).isAfter(moment().subtract(3, "years"))
                }
                onCollapse={() => {
                  resetField("prevstreet", formik);
                  resetField("prevhousenumber", formik);
                  resetField("prevpostcode", formik);
                  resetField("prevcity", formik);
                  resetField("prevcountry", formik);
                }}
              >
                <Fieldset>
                  <Fieldset.Row>
                    <Layout>
                      <Layout.Item default={"12/12"} m={"2/2"} xs={"1/1"}>
                        <b>
                          {Output.resolve(
                            "pages.applicationForm.panels.contactData.paragraph"
                          )}
                        </b>
                      </Layout.Item>
                    </Layout>
                  </Fieldset.Row>
                  <Fieldset.Row>
                    <Layout>
                      <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                        <FastField
                          name="prevstreet"
                          label={Output.resolve(
                            "pages.applicationForm.panels.contactData.fields.street.label"
                          )}
                          component={TextField}
                        />
                      </Layout.Item>
                      <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                        <FastField
                          name="prevhousenumber"
                          label={Output.resolve(
                            "pages.applicationForm.panels.contactData.fields.houseNumber.label"
                          )}
                          component={TextField}
                        />
                      </Layout.Item>
                    </Layout>
                  </Fieldset.Row>
                  <Fieldset.Row>
                    <Layout>
                      <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                        <FastField
                          name="prevpostcode"
                          label={Output.resolve(
                            "pages.applicationForm.panels.contactData.fields.postcode.label"
                          )}
                          component={TextField}
                        />
                      </Layout.Item>
                      <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                        <FastField
                          name="prevcity"
                          label={Output.resolve(
                            "pages.applicationForm.panels.contactData.fields.city.label"
                          )}
                          component={TextField}
                        />
                      </Layout.Item>
                    </Layout>
                  </Fieldset.Row>
                  <Fieldset.Row>
                    <Layout>
                      <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                        <FastField
                          name="prevcountry"
                          label={Output.resolve(
                            "pages.applicationForm.panels.contactData.fields.country.label"
                          )}
                          component={SelectField}
                        >
                          {Output.resolve("generic.countrylist", []).map(
                            ({ key: value, value: label }, index) => (
                              <option key={index} value={value}>
                                {label}
                              </option>
                            )
                          )}
                        </FastField>
                      </Layout.Item>
                    </Layout>
                  </Fieldset.Row>
                </Fieldset>
              </Conditional>
            )}
          />
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <Field
                  name="email"
                  label={Output.resolve(
                    "pages.applicationForm.panels.contactData.fields.mail.label"
                  )}
                  tooltip={Output.resolveAsMarkdown(
                    "pages.applicationForm.panels.contactData.fields.mail.toolTip"
                  )}
                  component={TextField}
                />
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <Fieldset.Row>
            <Layout>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name="mobilePhoneCountryCode"
                  label={Output.resolve(
                    "pages.applicationForm.panels.contactData.fields.telephonePrefix.label"
                  )}
                  component={SelectField}
                >
                  {Output.resolve(
                    "pages.applicationForm.panels.contactData.fields.telephonePrefix.values",
                    []
                  ).map(({ key: value, value: label }, index) => (
                    <option key={index} value={value}>
                      {label}
                    </option>
                  ))}
                </FastField>
              </Layout.Item>
              <Layout.Item default={"6/12"} m={"1/2"} xs={"1/1"}>
                <FastField
                  name="mobilePhoneNumber"
                  label={Output.resolve(
                    "pages.applicationForm.panels.contactData.fields.telephone.label"
                  )}
                  tooltip={Output.resolveAsMarkdown(
                    "pages.applicationForm.panels.contactData.fields.telephone.toolTip"
                  )}
                  component={TextField}
                />
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
        </Fieldset>
        <Fieldset>
          <Fieldset.Row>{buttons}</Fieldset.Row>
        </Fieldset>
      </Form>
    </FormSection2>
  );
}

ContactSection.defaultProps = {
  validate: Validation.select(
    "street",
    "housenumber",
    "postcode",
    "city",
    "postcode",
    "country",
    "residentSince",
    "prevstreet",
    "prevhousenumber",
    "prevpostcode",
    "prevcity",
    "prevcountry",
    "email",
    "mobilePhoneCountryCode",
    "mobilePhoneNumber"
  ),
};

export default ContactSection;
